import { render, staticRenderFns } from "./PopupWrap.vue?vue&type=template&id=b0a0e646&"
import script from "./PopupWrap.vue?vue&type=script&lang=js&"
export * from "./PopupWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports